/** The most follow-up buttons shown under an answer. */
export const MAX_FOLLOW_UPS = 3;

/**
 * Splits an assistant answer into the text to render and its follow-up questions (2026-10-29): the prompt asks the
 * model to end with `<followups>` one question per line `</followups>`. The block is removed from the text, also
 * while it is still streaming in (an opening tag with no close yet), so the raw tags never flash on screen. List
 * markers ("-", "1.") are stripped; empty lines dropped; at most {@link MAX_FOLLOW_UPS}.
 */
export function splitFollowUps(text: string): { body: string; followUps: string[] } {
  const open = text.indexOf("<followups>");
  if (open < 0) return { body: text, followUps: [] };
  const close = text.indexOf("</followups>", open);
  const inner = close < 0 ? "" : text.slice(open + "<followups>".length, close);
  const after = close < 0 ? "" : text.slice(close + "</followups>".length);
  const followUps = inner
    .split("\n")
    .map((line) => line.replace(/^\s*(?:[-*•]|\d+[.)])\s*/, "").trim())
    .filter((line) => line.length > 0)
    .slice(0, MAX_FOLLOW_UPS);
  return { body: (text.slice(0, open) + after).trimEnd(), followUps };
}
